import { Box, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import StockNumber from "components/StockNumber";
import { TRADE_SIDE } from "./constants";
import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function TradePrices({ coinMarketDetails }) {
  const [searchParams] = useSearchParams();
  const sideId = +searchParams.get("side") || 1;

  const high24h = useMemo(() => {
    if (sideId === TRADE_SIDE.Buy.id) {
      return coinMarketDetails?.high24HourBuy;
    }
    return coinMarketDetails?.high24HourSell;
  }, [sideId, coinMarketDetails]);

  const low24h = useMemo(() => {
    if (sideId === TRADE_SIDE.Buy.id) {
      return coinMarketDetails?.low24HourBuy;
    }
    return coinMarketDetails?.low24HourSell;
  }, [sideId, coinMarketDetails]);

  const change24h = useMemo(() => {
    if (sideId === TRADE_SIDE.Buy.id) {
      return coinMarketDetails?.changePCT24HourBuy;
    }
    return coinMarketDetails?.changePCT24HourSell;
  }, [sideId, coinMarketDetails]);

  return (
    <>
      <PriceBox>
        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          قیمت خرید از ما
        </Typography>
        <Detail color="success.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={coinMarketDetails?.priceBuy} />
          </TypographyStyle>
        </Detail>

        <Typography fontWeight={400} color="text.main" variant="subtitle2">
          قیمت فروش به ما
        </Typography>
        <Detail color="error.main">
          <TypographyStyle variant="span" fontWeight={700}>
            <NumberFormats value={coinMarketDetails?.priceSell} />
          </TypographyStyle>
        </Detail>
      </PriceBox>

      <PriceBox>
        <Title variant="subtitle2">High (24h)</Title>
        <Detail variant="h6" color="text.main">
          <NumberFormats value={high24h} />
        </Detail>

        <Title variant="subtitle2">Low (24h)</Title>
        <Detail variant="h6" color="text.main">
          <NumberFormats value={low24h} />
        </Detail>

        <Title variant="subtitle2">Change (24h)</Title>
        <StockNumber
          justifyContent="center"
          variant="subtitle1"
          value={change24h}
          hasArrows
        />
      </PriceBox>
    </>
  );
}

const PriceBox = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginBottom: theme.spacing(1),
  marginRight: theme.spacing(0.2),
  boxShadow: `0 0 5px 2px ${theme.palette.background.boxShadowPrices}`,
  border: `1px solid ${theme.palette.common.white}10`,
  padding: theme.spacing(1.5),
  borderRadius: "8px",
}));

const Title = styled(Typography)(({ theme }) => ({
  color: `${theme.palette.text.main}B3`,
  fontWeight: 400,
}));

const Detail = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
  },
}));

const TypographyStyle = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  '@media (max-width: 375px)': {
    fontSize: "12px",
  }
}));

export default TradePrices;
